An opaque cursor to the earlier bounding webhook attempt.

Resulting webhook attempts will _succeed_ this cursor.
